// extracted by mini-css-extract-plugin
export default {"button":"vvi7kG","animatedIcon":"TqIvDr","content":"StIhPb"};